<template>
  <div class="c-userinfo-container">
    <div class="userinfo-main">
      <!-- 头像姓名 -->
      <div class="user-header">
        <div class="header-avatar">
          <img :src="userinfo.headImg || defaultHeadImg" class="avatar-img">
        </div>
        <div class="user-names">
          <p class="user-name">{{ userinfo.cnName }}</p>
          <p class="user-id">ID: {{ userinfo.studyCard }}</p>
        </div>
      </div>
      <!-- 生日 -->
      <div class="user-info-item">
        <img src="../images/icon-birthday.png" class="user-info-item-img"/>
        <span class="user-info-item-value">{{ dayjs(userinfo.birthday).format('YYYY-MM-DD') }}</span>
      </div>
      <!-- 战队 -->
       <div class="user-info-team">
        <div class="user-info-item">
          <img src="../images/icon-team.png" class="user-info-item-img"/>
          <span class="user-info-item-value">战队：{{ classInfo.name }}</span>
        </div>
        <div class="user-info-item">
          <img src="../images/icon-teacher.png" class="user-info-item-img"/>
          <span class="user-info-item-value">队长：{{ classInfo.ownerName }}</span>
        </div>
       </div>
       <!-- 获得荣誉 -->
        <ul class="gift-list">
          <li class="gift-item">
            <img src="../images/icon-tower.png" class="gift-item-img"/>
            共计
            <span class="gift-num">{{ otherInfo.lessonNum }}</span>
            <span class="gift-label">完成关卡</span>
          </li>
          <li class="gift-item">
            <img src="../images/icon-gift.png" class="gift-item-img"/>
            共计
            <span class="gift-num">{{ otherInfo.giftNum }}</span>
            <span class="gift-label">获得礼物</span>
          </li>
          <!-- <li class="gift-item">
            <img src="../images/icon-reward.png" class="gift-item-img"/>
            共计
            <span class="gift-num">{{ userinfo.gift || 0 }}</span>
            <span class="gift-label">获得成就</span>
          </li> -->
        </ul>
    </div>

    <div class="user-image">
      <img :src="actualUserImage" class="image-display" />
      <img src="../images/user/role-shadow.png" class="user-shadow">
    </div>

    <ul class="stuff-menu-list">
      <li class="stuff-menu-item" @click="openStuffDialog(GoodsType.PROP)">
        <img src="../images/props.png" class="stuff-menu-item-img">
        <span class="stuff-menu-item-label">道具</span>
      </li>
      <!-- <li class="stuff-menu-item" @click="openStuffDialog(GoodsType.SKIN)">
        <img src="../images/spring.png" class="stuff-menu-item-img">
        <span class="stuff-menu-item-label">皮肤</span>
      </li> -->
      <li class="stuff-clothes" @click="openStuffDialog(GoodsType.DRESS_UP)">
        <img src="../images/icon-clothes.png" class="icon-clothes"/>
        换装
      </li>
    </ul>

    <MallDialog :visible.sync="stuffDialogVisible" :hideFooter="true" width="7.7rem" title="我的物品">
        <StuffList :list="currentStuffList">
          <StuffItem v-for="item in currentStuffList" :key="item.id" :detail="item" @used="handleUsedStuff" />
        </StuffList>
    </MallDialog>
  </div>
</template>

<script>
import dayjs from "dayjs"
import { mapState } from "vuex"
import { apiGetMallUserInfo } from "@/models/mall"
import { GoodsType } from "@/constants/mall"
import defaultHeadImg from "../images/user/headImg.png"
// import ClasscoreModel from "@/models/classcore"
import RoleBaseGirl from '../images/user/role-girl-base.png'
import RoleBaseBoy from '../images/user/role-boy-base.png'
import RoleDinosaur from '../images/user/role-dinosaur.png'
import MallDialog from "@/components/mall-dialog/index.vue"
import StuffList from "./StuffList.vue"
import StuffItem from "./StuffItem.vue"

// const classCoreModel = new ClasscoreModel()

export default {
  name: "UserInfo",
  components: {
    MallDialog,
    StuffList,
    StuffItem,
  },
  data() {
    return {
      dayjs,
      GoodsType,
      defaultHeadImg,
      RoleBaseGirl,
      RoleBaseBoy,
      RoleDinosaur,
      userinfo: {}, // 用户信息
      classInfo: {}, // 班级信息
      otherInfo: {},
      cupList: "", //奖杯信息
      stuffDialogVisible: false,
			allAssets: [],
      selectedType: "",
    }
  },
	computed: {
    ...mapState({
      userImage: (state) => state.goods.userImage,
    }),
		// 装扮列表
		dressList() {
			return this.allAssets.filter((item) => item.type === GoodsType.DRESS_UP)
		},
		// 皮肤列表
		skinList() {
			return this.allAssets.filter((item) => item.type === GoodsType.SKIN)
		},
		// 道具列表
		propList() {
      // 对道具进行分组
      const propList = this.allAssets.filter((item) => item.type === GoodsType.PROP) || []
      // 根据道具的 productName 进行分组
      const propGroupList = propList.reduce((acc, cur) => {
        const productName = cur.productName
        if (!acc[productName]) {
          acc[productName] = {
            goods: [cur],
            type: cur.type,
            cover: cur.cover,
            productName,
          }
        } else {
          acc[productName].goods.push(cur)
        }
        return acc
      }, {})

      console.log(propGroupList)
      return Object.values(propGroupList) || []
		},
    currentStuffList() {
      let currentStuffList
      switch (this.selectedType) {
        case GoodsType.DRESS_UP:
          currentStuffList = this.dressList
          break
        case GoodsType.SKIN:
          currentStuffList = this.skinList
          break
        case GoodsType.PROP:
          currentStuffList = this.propList
          break
        default:
          currentStuffList = []
      }
      return currentStuffList
    },
    // 用户形象
    actualUserImage() {
      const defaultImage = this.userinfo.sex === 1 ? RoleBaseBoy : RoleBaseGirl
      const usedDress = this.dressList.find((dress) => dress.status === 1)
      return this.userImage || (usedDress ? usedDress.img : defaultImage)
    },
	},
  methods: {
    //获取用户信息，并准备应用于退出时的ID
    async getUserInfo() {
      const {data} = await apiGetMallUserInfo()
      this.userinfo = data.user || {}
      this.classInfo = data.classInfo || {}
      this.allAssets = data.asset || []
      this.otherInfo = {
        giftNum: data.giftNum || 0,
        lessonNum: data.lessonNum || 0,
      }
      this.$emit("userInfo", this.userinfo)
    },
    openStuffDialog(type) {
      this.stuffDialogVisible = true
      this.selectedType = type
    }, 
    handleUsedStuff() {
      this.getUserInfo()
    },
  },
  mounted() {
    this.getUserInfo()
  },
}
</script>

<style scoped>
.c-userinfo-container {
  position: relative;
  display: flex;
  justify-content: space-between;
}
.userinfo-main{
  display: flex;
  flex-direction: column;
}
.user-header {
  display: flex;
  align-items: center;
}
.header-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  margin-right: 16px;
  background: #fff3d3;
  box-shadow: 0px 1px 3px 0px rgba(103,27,6,0.61), 0px -1px 1px 0px rgba(217,138,67,0.80) inset; 
  border-radius: 50%;
}
.avatar-img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.user-names {
  text-align: left;
}
.user-name {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
}
.user-id {
  margin: 0;
  margin-top: 12px;
  font-size: 20px;
  color: #fff;
}

.user-info-item {
  display: flex;
  align-items: center;
  margin-top: 24px;
  width: 236px;
  height: 50px;
  padding: 0 20px;
  background: #fff3d3;
  border-radius: 40px;
  box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset; 
  overflow: hidden;
}
.user-info-team {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.user-info-item-img {
  width: 30px;
  height: 30px;
}
.user-info-item-value {
  flex-shrink: 0;
  margin-left: 12px;
  font-size: 24px;
  color: #6F6C68;
  overflow: hidden;
}

.gift-list {
  display: flex;
  /* justify-content: space-around; */
  gap: 28px;
  list-style: none;
  margin: 0;
  margin-top: 32px;
  padding: 0;
}
.gift-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 180px;
  padding: 20px 0;
  border-radius: 24px;
  box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset;
  background: url('../images/gift-item-bg.png') center bottom/100% no-repeat #fff3d3;
  font-size: 20px;
  color: #818181;
}
.gift-item-img {
  width: 54px;
  height: 58px;
  margin-bottom: 12px;
}
.gift-num {
  margin-top: 8px;
  font-size: 34px;
  font-weight: 700;
  color: #8bb91c;
}
.gift-label {
  font-size: 24px;
  font-weight: bold;
  color: #6f6c68;
}

.user-image {
  position: absolute;
  bottom: 0;
  right: 152px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.image-display {
  width: 280px;
  margin-bottom: -48px;
}
.user-shadow {
  width: 400px;
  margin-top: -20px;
  margin-bottom: -40px;
}

.stuff-menu-list {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  padding: 0;
  margin: 0;
  list-style: none;
}
.stuff-menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  height: 110px;
  background: #fff3d3;
  border-radius: 28px;
  box-shadow: 0px 1px 3px 0px rgba(103,27,6,0.61), 0px -1px 1px 0px rgba(217,138,67,0.80) inset; 
}
.stuff-menu-item-img {
  width: 82px;
  height: 72px;
  margin-top: 8px;
  border-radius: 28px;
}
.stuff-menu-item-label {
  margin-top: 2px;
  font-size: 16px;
  font-weight: bold;
  color: #b18f54;
}
.stuff-clothes {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 163px;
  height: 49px;
  background: #ffe952;
  border-radius: 24px;
  box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ffbe31 inset; 
  color: #DD7146;
  font-size: 24px;
  font-weight: bold;
}
.icon-clothes {
  width: 34px;
  height: 34px;
  margin-right: 8px;
  margin-top: -2px;
}
</style>